export const COLLECTION_KEYS = {
    ALL: 'all',
    CRYPTO: 'crypto',
    FAVORITES: 'favorites',
    FOREX: 'forex',
    INDICES: 'indices',
    LAST_VIEWED: 'last_viewed',
    MATERIALS: 'materials',
    POPULAR: 'popular',
    STOCKS: 'stocks',
    UPS_DOWNS: 'ups_downs',
} as const

export const COLLECTION_ASSETS_ATTRIBUTES = {
    ASSET_CLASS: 'asset_class',
} as const
